/**
 * What an operator says they are doing in a workspace. Hand-synced with messaging-gateway
 * `src/modules/operator-status/availability.ts`.
 */
export const OPERATOR_STATUSES = ['working', 'break', 'off'] as const;
export type OperatorStatus = (typeof OPERATOR_STATUSES)[number];

/** Why someone cannot be given a conversation: their own status, else no connection. */
export type Unavailable = 'break' | 'off' | 'offline';

/** Anything this build does not know (a newer gateway) reads as working — the gateway decides anyway. */
export function parseStatus(value: unknown): OperatorStatus {
  return typeof value === 'string' && (OPERATOR_STATUSES as readonly string[]).includes(value)
    ? (value as OperatorStatus)
    : 'working';
}
